/**
 * Login related utility functions
 */

import getConfig from 'next/config';

import {Cookie} from '~/src/utilities/constants/cookie';
import {getApiRequest, deleteApiRequest} from '~/src/utilities/feed/api';
import {getCookieJson} from '~/src/utilities/helpers/cookie';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import {trackGtm} from '~/src/utilities/tracking/gtm';
import {getRootPath} from '~/src/utilities/helpers/link';

const {publicRuntimeConfig: config} = getConfig();

const isExpired = (sessionUser) => {
    return !sessionUser.expire || new Date(sessionUser.expire).getTime() < Date.now();
};

const userIsLoggedIn = () => {
    const sessionUser = getCookieJson(Cookie.SESSION);
    return !!(sessionUser && sessionUser.userId);
};

const userHasSession = () => {
    const sessionUser = getCookieJson(Cookie.SESSION);
    return sessionUser && !isExpired(sessionUser);
};

const login = () => {
    trackGtm(GtmEvents.LOGIN_ATTEMPT, null);
    window.location.href = `${config.accounts.loginUrl}?target_uri=${encodeURIComponent(window.location.href)}&lang=${config.language}`;
};

const logout = async () => {
    await resetUser();
    window.location.href = getRootPath();
};

const resetUser = () => deleteApiRequest(config.accounts.logoutUrl);
const refreshUser = () => getApiRequest(config.accounts.refreshUrl, true);

export {userIsLoggedIn, userHasSession, login, logout, resetUser, refreshUser};
